import { TourDefinition } from "./tourTypes";
import { introTour } from "./tours/introTour";
import { screenTours } from "./tours/screenTours";

// Module-level registry of tours, keyed by tour id. Per-screen mini-tours plug in
// by adding a definition to tours/screenTours.ts (or calling registerTour()).
const registry: Record<string, TourDefinition> = {};

export const registerTour = (tour: TourDefinition): void => {
  registry[tour.id] = tour;
};

export const getTour = (id: string): TourDefinition | undefined => registry[id];

export const getAllTours = (): TourDefinition[] => Object.values(registry);

// Built-in tours.
registerTour(introTour);
screenTours.forEach(registerTour);
